<app-loading *ngIf="contentReady"></app-loading>

<div class="cart-container" style="margin-bottom: 70px;">

  <!-- ✅ Progress Bar -->
  <div class="cart-summary">
    @if(order_status != 3){

    <div class="progress-br">

      <div>
        <div class="progress-br-step" [class.active]="order_status == 1">1</div>
        <div class="progress-br-label">{{ "pending" | transloco }}</div>
      </div>

      <div>
        <div class="progress-br-step" [class.active]="order_status == 2">2</div>
        <div class="progress-br-label">{{ "approved" | transloco }}</div>
      </div>

      <div>
        <div class="progress-br-step" [class.active]="order_status == 4">3</div>
        <div class="progress-br-label">{{ "withdelivery" | transloco }}</div>
      </div>

      <div>
        <div class="progress-br-step" [class.active]="order_status == 5">4</div>
        <div class="progress-br-label">{{ "shipped" | transloco }}</div>
      </div>

    </div>

    } @else {

    <div style="text-align: center;">
      <img src="/assets/e-commerce/icons/69.webp" alt="product" class="product-img">
      <p>{{ "canceled order" | transloco }}</p>
    </div>

    }
  </div>

  <!-- ✅ Products Section -->
  <div class="cart-summary">

    <div class="total order-info">
      <p>{{ 'products' | transloco }}</p>
    </div>

    <!-- ✅ Loop Items -->
    <div class="cart-item" *ngFor="let line of orderLines">

      <!-- Product Image -->
      <img class="product-image pointer" *ngIf="line.product?.image" (click)="openDetails(line.product)"
        [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="fixImage(line.product.image)"
        [errorImage]="'/assets/imageloading.gif'" alt="product" />

      <!-- Fallback لو مفيش صورة -->
      <img class="product-image" *ngIf="!line.product?.image" src="/assets/imageloading.gif" alt="product" />

      <!-- Product Details -->
      <div class="product-details">

        <!-- Name -->
        <p class="product-name">
          @if(line.product){
          @if(isAr){
          {{ line.product.name_ar }}
          } @else {
          {{ line.product.name_en }}
          }
          } @else {
          {{ line.name }}
          }
        </p>

        <!-- Quantity -->
        <div class="quantity-controls">
          <span>{{ 'quantity' | transloco }}: {{ line.qty }}</span>
        </div>

        <!-- Price -->
        <div class="price">
          <span class="new-price">
            {{ line.price }} {{ "egpe" | transloco }}
          </span>

          @if(line.product && calcDis(line.price, line.product.pricec) != 0 && line.price > 0){
          <span class="old-price">
            {{ line.product.pricec }} {{ "egpe" | transloco }}
          </span>
          }
        </div>

        <!-- ✅ Bundle Items -->
        <div class="bundle-items-premium" *ngIf="line.product?.items?.length">
          <p class="bundle-title">
            {{ "Show Bundle Items" | transloco }}
          </p>

          <div class="bundle-chip" *ngFor="let bItem of line.product.items">
            <div class="chip-img">
              <img [lazyLoad]="fixImage(bItem.stock.image)" />
            </div>

            <div class="chip-text">
              <span class="chip-qty">×{{ bItem.quantity }}</span>

              <span class="chip-name">
                {{ isAr ? bItem.stock.name_ar : bItem.stock.name_en }}
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!-- ✅ Order Info -->
  <div class="cart-summary">
    <div class="total order-info">

      <p>{{ 'Date' | transloco }}: {{ date }}</p>
      <p class="order-id">{{ "order number" | transloco }} #{{ invoiceId }}</p>
      <p>{{ "address" | transloco }}: {{ address }}</p>

      <p>
        <span>{{ "subtotal" | transloco }}</span>:
        <span>{{ total - deliveryfees }} {{ "egpe" | transloco }}</span>
      </p>

      <p>
        <span>{{ "delivery fees" | transloco }}</span>:
        <span>{{ deliveryfees }} {{ "egpe" | transloco }}</span>
      </p>

      <p class="total">
        <span>{{ "total" | transloco }} :</span>
        <span>{{ total }} {{ "egpe" | transloco }}</span>
      </p>

    </div>
  </div>

  <!-- ✅ Maps -->
  <div class="cart-summary">
    <div class="total order-info">
      <p>{{ 'Google Maps Link' | transloco }}</p>
      <app-maps [order_location]="order_location"></app-maps>
    </div>
  </div>

</div>